module.exports = __webpack_public_path__ + "a2b2cbca0d12de9e3241c23463f84b7e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-semibold.svg
// module id = 38
// module chunks = 0 1 2 3 4 5 6 7 8 9